import React, { useState, useContext, useEffect } from 'react'
import { useHeartbeats } from '../../hooks/data/use-heartbeats'
import { isEmptyString } from '../../utils/string-utils'
import { AuthContext } from '../../context/auth/auth-context'
import { Chip } from '@mui/material'

export interface TradingStatusChipProps {
  strategyId: string
}

const TradingStatusChip: React.FC<TradingStatusChipProps> = ({ strategyId }) => {
  const { isAuthorized, accessToken } = useContext(AuthContext)
  const heartbeats = useHeartbeats(isAuthorized, accessToken)

  const [isTradingPaused, setIsTradingPaused] = useState<string>('')

  useEffect(() => {
    const matchingHeartbeat = heartbeats.find(heartbeat => heartbeat.strategyId === strategyId)
    if (matchingHeartbeat != null) {
      setIsTradingPaused(matchingHeartbeat.isTradingPaused)
    } else {
      setIsTradingPaused('')
    }
  }, [heartbeats])

  return (
    <Chip
      size='small'
      label={isEmptyString(isTradingPaused) ? 'No Heartbeat Found' : (isTradingPaused === 'true' ? 'Paused' : 'Trading')}
      color={isEmptyString(isTradingPaused) ? 'default' : (isTradingPaused === 'true' ? 'error' : 'success')}
    />
  )
}

export default React.memo(TradingStatusChip)
